<template>
  <v-row class="voucher">
    <v-col>
      <v-row>
        <v-col cols="8" class="company">
          {{company.companyName}}
          <br />
          Phone : {{company.phoneNo}}
          <br />
          {{ new Date() | formatDateOnly}}
        </v-col>
        <v-col cols="4">
          <barcodeview :id="voucher.id" :code="voucher.code" :width="width" :height="height"></barcodeview>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <table class="voucher-table" width="100%">
            <tbody>
              <tr>
                <td>
                  From
                  <br />
                  {{voucher.fromCity}}
                </td>
                <td>{{voucher.osName}} &nbsp;&nbsp; {{voucher.osPhone}}</td>
              </tr>
              <tr>
                <td>
                  To
                  <br />
                  {{voucher.toCity}}
                </td>
                <td>{{voucher.customerName}} &nbsp;&nbsp; {{voucher.customerPhone}} {{voucher.customerAddress}}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="itemName">{{voucher.itemName}}</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="footer">
          <p class="total">Total: {{voucher.totalPrice}} MMK</p>
          Remark: {{voucher.remark}}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import BarCodeView from "../components/BarCodeView";
export default {
  data() {
    return {};
  },
  props: {
    voucher: {
      itemId: {
        type: Number,
        default: 0
      },
      fromCity: "Mdy",
      toCity: "Ygn",
      osName: "Nay Chi",
      osPhone: "099877775",
      customerName: "Mi Chaw",
      customerAddress: "DawPone Tharkayta, Yangon",
      customerPhone: "099700234",
      totalPrice: {
        type: Number,
        default: 0
      },
      remark: {
        type: String,
        default: ""
      },
      code: {
        type: String,
        default: "Q9"
      },
      id: {
        type: Number,
        default: 0
      }
    },

    width: {
      type: Number,
      default: 150
    },
    height: {
      type: Number,
      default: 150
    },
    padding: {
      type: Number,
      default: 0
    },
    company: {
      companyName: {
        type: String,
        default: ""
      },
      phoneNo: {
        type: String,
        default: ""
      }
    },
    file: {
      type: String,
      default: ""
    }
  },
  mounted: function() {},
  methods: {},
  computed: {
    styleCode: function() {
      return {
        display: "block",
        position: "relative",
        top: 0,
        left: 0,
        padding: this.padding + "px"
      };
    }
  },
  components: {
    barcodeview: BarCodeView
  }
};
</script>
<style scoped>
@import "/css/barcode-gen.css";
</style>